module.exports = __webpack_public_path__ + "static/media/03-2-galeria-05-thomas-sabo@2x.749fdaa2.jpg";